import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { attachmentsActionTypes } from '../reducer';

function* getFiles() {
  yield requestSaga({
    actionType: attachmentsActionTypes.getList,
    request: dataProvider.getList,
    resource: resources.files.index,
  });
}

export default getFiles;
